import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=4b20f5ef&scoped=true"
var script = {}
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=4b20f5ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20f5ef",
  null
  
)

export default component.exports